var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeerbitWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 5587.4 877.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff3c38;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Seerbit white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 13.94,
    y: -9.56,
    width: 873.21,
    height: 896.77,
    transform: "matrix(0, -1, 1, 0, 9.49, 887.19)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M125.36,498.66l649.76,3.22L777,131.2,127.2,128ZM651.47,377.83l-399.2-2,.61-123.5,399.2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M124.75,622.34l649.76,3.22-.38,77.11a46.4,46.4,0,0,1-46.63,46.16l-603.37-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1061.84,132.53,1679,135.6l-.44,87.63A36,36,0,0,1,1642.38,259l-457.71-2.27L1184.06,380l493.69,2.45L1675.92,753l-581.15-2.88A36,36,0,0,1,1059,713.9l.44-87.63,493.73,2.45.62-123.41L1060,502.86Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1801.88 259.83 1802.35 136.21 2419.53 139.27 2418.91 262.89 1801.88 259.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2417.8,633.19l-.44,87.85a36,36,0,0,1-36.17,35.81l-581-2.89,1.44-370.69,616.71,3.06-.61,123.45-493.95-2.45-.61,123.44Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2542.43 263.51 2542.9 139.88 3160.07 142.94 3159.46 266.57 2542.43 263.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3158.34,636.86l-.43,87.85a36,36,0,0,1-36.17,35.81l-581.22-2.88L2542,387,3158.78,390l-.61,123.44-494-2.45-.61,123.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4641.13,150.29,4024,147.23,4020.93,765l563.15,2.79A54,54,0,0,0,4638.34,714l1-193.41-61.42-62,62-61.45ZM4515.24,643.42,4145,641.58l.61-123.41L4515.85,520Zm1.23-246.85-370.3-1.84.62-123.44,370.29,1.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4764.54,150.91l123.44.61-3.06,617.35-69.46-.34a54,54,0,0,1-53.71-54.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4970.26,151.93,5587.4,155l-.62,123.44-246.84-1.22-2.45,493.91-69.47-.34a54,54,0,0,1-53.71-54.25l2.18-439.93-246.85-1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3283.45,143.56,3282.83,267l493.74,2.45L3776,392.89l-493.74-2.45-1.84,370.47,87.45.44A36,36,0,0,0,3404,725.54l1.05-210.9,123.41.61,182,210.8a108,108,0,0,0,81.19,37.4l105.91.52-216.65-248.1L3898.75,517l1.84-370.33Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeerbitWhite);
export default __webpack_public_path__ + "static/media/SeerbitWhite.4efb2e14abc9d6c4ee15dc8d5d6b2718.svg";
export { ForwardRef as ReactComponent };